import React, { useEffect } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest, putRequest } from "../services/apiMethods";
import { GetVerifiedValidationSchema } from "../utils/Validations";
import useImageUploader from "../hooks/UploadImage";
import useVendorDetails from "../hooks/VendorDetails";
import { isPdfExtensions } from "../utils/commFunction";
import toast from "react-hot-toast";
import useDocumentUploader from "../hooks/UploadDocument";


export default function GetVerified() {
  const Navigate = useNavigate()
  const { data: verifyDetailsGet, isLoading } = useVendorDetails();
  const { uploadImage, loading, error, uploadedUrl, errorMessage } = useImageUploader();  // Call the hook here
  const {uploadDocumnetImage, uploadedDocumnetUrl, } = useDocumentUploader(); 
  
  

  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      if (verifyDetailsGet?.verification?.companyRegisterNo) {
        const modifyData = {
          id: data?._id,
          companyRegisterNo: data?.companyRegisterNo || "",
          govermentBodyListedWith: data?.govermentBodyListedWith || "",
          RegisterNo: data?.RegisterNo || "",
          insurancePolicyNo: data?.insurancePolicyNo || "",
          image: data?.image || "",
          document: data?.document || ""
        };
        return putRequest(`/verification/edit`, modifyData);
      } else {
        const modifyData = {
          companyRegisterNo: data?.companyRegisterNo || "",
          govermentBodyListedWith: data?.govermentBodyListedWith || "",
          RegisterNo: data?.RegisterNo || "",
          insurancePolicyNo: data?.insurancePolicyNo || "",
          image: data?.image || "",
          document: data?.document || ""
          
        };
        return postRequest(`/verification/create`, modifyData);
      }

    },
    onSuccess: (data) => {
      toast.success(`${data?.message}`, {
        iconTheme: {
          primary: '#337FE0',
          secondary: '#FFFAEE',
        },
      })
      Navigate(-1)
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const initial = {
    companyRegisterNo: "",
    govermentBodyListedWith: "",
    RegisterNo: "",
    insurancePolicyNo: "",
    image: "",
    document:""
  }

  const formik = useFormik({
    initialValues: verifyDetailsGet?.verification || initial,
    enableReinitialize: true,
    validationSchema: GetVerifiedValidationSchema,
    onSubmit: (values) => {
       mutate(values)
    },
  });



  useEffect(() => {
    if (uploadedUrl) {
      formik.setFieldValue("image", uploadedUrl);
    }
  }, [uploadedUrl]);

  useEffect(() => {
    if (uploadedDocumnetUrl) {
      formik.setFieldValue("document", uploadedDocumnetUrl);
    }
  }, [uploadedDocumnetUrl]);


  

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate("/settings")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>
            <Row>
              <Col lg={8}>
                <div className="my-profile-card-contain">
                  <div className="my-profile-title">
                    <h4>Get Verified</h4>
                    <p>
                      We pride ourselves on connecting customers with qualified and reputable companies. Submit a verification request, and our team will conduct a review of your company to get you verified. Once approved, you’ll receive a verified badge on your profile - helping you stand out and build trust with potential customers.
                    </p>
                  </div>
                  <div className="my-profile-box-contain">
                    <div className="my-profile-box-form">
                      <div className="form-box-title">
                        <h4>More Information</h4>
                        <p>
                          Provide the following information and we’ll arrange
                          the next steps.
                        </p>
                      </div>
                      <form onSubmit={formik.handleSubmit} className="cmn-form-set">
                        <div className="mb-3">
                          <label>Company Registration Number</label>
                          <input
                            type="text"
                            className={`form-control ${formik.touched.companyRegisterNo && formik.errors.companyRegisterNo ? "is-invalid" : ""
                              }`}
                            name="companyRegisterNo"
                            onChange={(e) => {
                              const upperCaseValue = e.target.value.toUpperCase();
                              formik.setFieldValue("companyRegisterNo", upperCaseValue); // Directly update the field value
                            }}
                            onBlur={formik.handleBlur}
                            placeholder="Type here"
                            value={formik.values.companyRegisterNo}
                          />
                          {formik.touched.companyRegisterNo && formik.errors.companyRegisterNo && (
                            <div className="invalid-feedback">{formik.errors.companyRegisterNo}</div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label>Government Body Listed With</label>
                          <input
                            type="text"
                            className={`form-control ${formik.touched.govermentBodyListedWith && formik.errors.govermentBodyListedWith ? "is-invalid" : ""
                              }`}
                            name="govermentBodyListedWith"
                            onChange={formik.handleChange}
                            placeholder="Type here"
                            onBlur={formik.handleBlur}
                            value={formik.values.govermentBodyListedWith}
                          />
                          {formik.touched.govermentBodyListedWith && formik.errors.govermentBodyListedWith && (
                            <div className="invalid-feedback">{formik.errors.govermentBodyListedWith}</div>
                          )}
                        </div>

                        <Row className="align-items-center">
                          <Col lg={6}>
                            <div className="mb-3">
                              <label>Registration Number</label>
                              <input
                                type="text"
                                className={`form-control ${formik.touched.RegisterNo && formik.errors.RegisterNo ? "is-invalid" : ""
                                  }`}
                                name="RegisterNo"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                placeholder="Type here"
                                value={formik.values.RegisterNo}
                              />
                              {formik.touched.RegisterNo && formik.errors.RegisterNo && (
                                <div className="invalid-feedback">{formik.errors.RegisterNo}</div>
                              )}
                            </div></Col>
                          <Col lg={6}>
                            <div className="mb-3">
                              <label>Insurance Policy Number</label>
                              <input
                                type="text"
                                className={`form-control ${formik.touched.insurancePolicyNo &&
                                  formik.errors.insurancePolicyNo
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                name="insurancePolicyNo"
                                onChange={(e) => {
                                  const upperCaseValue = e.target.value.toUpperCase();
                                  formik.setFieldValue("insurancePolicyNo", upperCaseValue); // Directly update the field value
                                }}
                                placeholder="Type here"
                                onBlur={formik.handleBlur}
                                value={formik.values.insurancePolicyNo}
                              />
                              {formik.touched.insurancePolicyNo &&
                                formik.errors.insurancePolicyNo && (
                                  <div className="invalid-feedback">
                                    {formik.errors.insurancePolicyNo}
                                  </div>
                                )}
                            </div>
                          </Col>
                          <Col lg={6}>

                          <div className="mb-3 insurance-doc-pre">
                              {formik?.values?.image &&
                                <>
                                  {isPdfExtensions(formik.values.image) ?
                                    (
                                      <img
                                        src={require("../assets/images/pdfIMG.png")}
                                        alt="pdf icon"
                                        height={50}
                                        width={50}
                                      />
                                    ) :
                                    (
                                      <img
                                        src={formik.values.image || require("../assets/images/dimmy-img.png")}
                                        alt="image"
                                        height={50}
                                        width={50}
                                      />
                                    )}


                                </>
                              }
                            </div>
                            <div className="mb-3">
                              <label>Upload Insurance Document</label>


                              <div className="cmpny-logo-upld mt-1 mb-0">
                                <input
                                  type="file"
                                  accept="image/*,.pdf"
                                  className={`form-control ${formik.touched.image &&
                                    formik.errors.image
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  name="image"
                                  onChange={async (event) => {
                                    const file = event.target.files[0];
                                    if (file) {
                                      await uploadImage(file); // Wait for image upload
                                      formik.setFieldValue("image", uploadedUrl); // Set the uploaded image URL
                                    }
                                  }}
                                />
                                <button type="button" className="white-btn">
                                  Upload Photo
                                </button>

                                {formik.touched.image &&
                                  formik.errors.image && (
                                    <div className="invalid-feedback ">
                                      {formik.errors.image}
                                    </div>
                                  )}
                              </div>
                      

                            </div>

                          </Col>
             


                          <Col lg={6}>


                          <div className="mb-3 insurance-doc-pre">
                              {formik?.values?.document &&
                                <>
                                  {isPdfExtensions(formik.values.document) ?
                                    (
                                      <img
                                        src={require("../assets/images/pdfIMG.png")}
                                        alt="pdf icon"
                                        height={50}
                                        width={50}
                                      />
                                    ) :
                                    (
                                      <img
                                        src={formik.values.document || require("../assets/images/dimmy-img.png")}
                                        alt="image"
                                        height={50}
                                        width={50}
                                      />
                                    )}


                                </>
                              }
                            </div>
                            <div className="mb-3">
                              <label>Upload Document (passport or driving licence)</label>


                              <div className="cmpny-logo-upld mt-1 mb-0">
                                <input
                                  type="file"
                                  accept="image/*,.pdf"
                                  className={`form-control ${formik.touched.document &&
                                    formik.errors.document
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  name="document"
                                  onChange={async (event) => {
                                    const file = event.target.files[0];
                                    if (file) {
                                      await uploadDocumnetImage(file); // Wait for image upload
                                      formik.setFieldValue("document", uploadedDocumnetUrl); // Set the uploaded image URL
                                    }
                                  }}
                                />
                                <button type="button" className="white-btn">
                                  Upload Photo
                                </button>

                                {formik.touched.document &&
                                  formik.errors.document && (
                                    <div className="invalid-feedback ">
                                      {formik.errors.document}
                                    </div>
                                  )}
                              </div>
                      

                            </div>

                          </Col>


                     






                        </Row>
                        <button type="submit"
                          className={verifyDetailsGet?.verificationStatus == "Declined" ? "theme-comm-btn-disabled" : "theme-comm-btn"}
                          disabled={verifyDetailsGet?.verificationStatus == "Declined"}>
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={4}></Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
